import { readLocalStorage, writeLocalStorage } from "../model/localStoragePreference.ts";

export type Language = "en" | "es";

const LOCAL_STORAGE_KEY = "swmm-language";

function browserLanguage(): Language {
  return navigator.language.toLowerCase().startsWith("es") ? "es" : "en";
}

export function readSavedLanguage(): Language {
  const saved = readLocalStorage(LOCAL_STORAGE_KEY);
  if (saved === "es" || saved === "en") return saved;
  return browserLanguage();
}

export function saveLanguage(language: Language): void {
  writeLocalStorage(LOCAL_STORAGE_KEY, language);
}

export function localeFor(language: Language): string {
  return language === "es" ? "es-ES" : "en-US";
}
